import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],
    encapsulation: ViewEncapsulation.None,
  
})
export class EmployeesComponent implements OnInit {

  public employee: any[] = [];
  public messages: any = {};

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,        private toastr : ToastrService , 
    private translate: TranslateService
  ) {} 
    public pages  : any

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;

  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

  ngOnInit(): void {
    this.apisService.employee().subscribe({ 
      next:(response:any)=> { 
        this.employee = response.data || [] ;
        console.log('response is' , this.employee)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })

     this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this.translate.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this.translate.instant('MENU.DASHBOARD.total')
    };
  }

               getTags(){ 
  this.apisService.employee().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
        this.employee = response.data || [] ;

      this.totalItems = this.employee.length;
      console.log("employee:", this.employee);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }
 
 
 /*----------  Handling image Error  ----------*/
 onImageError(event) {
  event.target.src = 'assets/images/logo/12.png';
 }
  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

 
  // 🔹 Call search API dynamically
  filterUpdate(event: any): void {
    const searchTerm = event.target.value.trim();

    if (searchTerm === '') {
      // If input cleared → reload full list
      this.getTags();
      return;
    }

    this.apisService.searchImployee(searchTerm).subscribe({
      next: (response: any) => {
        this.employee = response.data;
        this.totalItems = this.employee.length;
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

  confirmDelete(id: any) {
  Swal.fire({
    title: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.translate.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this.translate.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.deleteProduct(id);
    }
  });
}
   /*----------  deleting products  ----------*/
deleteProduct(id: any) { 
  this.apisService.DeleteEmployee(id).subscribe({
    next: (response: any) => {
      this.toastr.success(
        this.translate.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );
      this.getTags();
    },
    error: (error: any) => {
      console.log(error);
      this.toastr.error(
        this.translate.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );
    }
  });
}


editProduct(productId: number) {
  this.router.navigate(['/edit-employees', productId]);
}

viewDetails(productId: number) {
  this.router.navigate(['/employees-details', productId]);
}


}